import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import WhatsAppFloat from "./components/WhatsAppFloat";
import { useEffect } from "react";
import Home from "./pages/Home";
import About from "./pages/About";
import Portfolio from "./pages/portfolio";
import Services from "./pages/Services";
import Contact from "./pages/Contact";

import HydraulicCylinderRefurbishment from "./pages/services/HydraulicCylinderRefurbishment";
import HydraulicPumpReconditioning from "./pages/services/HydraulicPumpReconditioning";
import HydraulicMotorsRefurbish from "./pages/services/HydraulicMotorsRefurbish";
import OnsiteHydraulicServices from "./pages/services/OnsiteHydraulicServices";
import RockBreakerRefurbishment from "./pages/services/RockBreakerRefurbishment";
import HydraulicCircuitBlocks from "./pages/services/HydraulicCircuitBlocks";
import UnderCarriageRefurbishment from "./pages/services/UnderCarriageRefurbishment";
import ControlValveRefurbishment from "./pages/services/ControlValveRefurbishment";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Smooth scroll for regular navigation
    const timer = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }, 0);
    
    // For initial page load or direct URL access
    window.onload = () => {
      window.scrollTo(0, 0);
    };

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <WhatsAppFloat />
      <Routes>
        <Route path="/HHS" element={<Home />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/hydraulic-cylinder-refurbishment" element={<HydraulicCylinderRefurbishment />} />
        <Route path="/services/hydraulic-pump-reconditioning" element={<HydraulicPumpReconditioning />} />
        <Route path="/services/hydraulic-motors-refurbish" element={<HydraulicMotorsRefurbish />} />
        <Route path="/services/onsite-hydraulic-services" element={<OnsiteHydraulicServices />} />
        <Route path="/services/rock-breaker-refurbishment" element={<RockBreakerRefurbishment />} />
        <Route path="/services/hydraulic-circuit-blocks" element={<HydraulicCircuitBlocks />} />
        <Route path="/services/undercarriage-refurbishment" element={<UnderCarriageRefurbishment />} />
        <Route path="/services/control-valve-refurbishment" element={<ControlValveRefurbishment />} />
        <Route path="/contact" element={<Contact />} />
        {/* Add a catch-all route for 404 pages */}
        <Route path="*" element={<Home />} />
      </Routes>
    </div>
  );
}

export default App;
